<div
  class="search-trade"
  (clickOutside)="closeWhenOutsideClick($event)"
  (attachOutsideOnClick)="(attachedClick)"
>
  <div class="search">
    <input
      #searchInput
      required
      class="search"
      type="text"
      [ngModel]="filterText"
      (ngModelChange)="changeFilter($event)"
      [class.filled]="showIconClose === true"
      [disabled]="disabled"
      (focus)="onInputFocus($event)"
      (click)="$event.target.select()"
    />
    <label>{{ placeholder }}</label>
    <div
      class="reset-state icon-cancel"
      (click)="clearBox()"
      *ngIf="showIconClose"
    ></div>
  </div>

  <div class="extra-data" *ngIf="showExtraData && priceDetail?.last">
    <div class="last">
      <span
        class="icon"
        [class.icon-arrow-cero]="priceDetail.changeAvg === 0"
        [class.icon-arrow-sube]="priceDetail.changeAvg > 0"
        [class.icon-arrow-baja]="priceDetail.changeAvg < 0"
        [class.neutro]="priceDetail.changeAvg === 0"
        [class.positive]="priceDetail.changeAvg < 0"
        [class.negative]="priceDetail.changeAvg < 0"
      >
      </span>
      <span
        [class.neutro]="priceDetail.changeAvg === 0"
        [class.positive]="priceDetail.changeAvg > 0"
        [class.negative]="priceDetail.changeAvg < 0"
      >
        {{
          isUsaContract && propertyForDisplayedPrice
            ? (priceDetail[propertyForDisplayedPrice]
              | hbCustomFormat
                : (priceDetail[propertyForDisplayedPrice] < 1
                    ? '$0,0[.]000'
                    : '$0,0[.]00'))
            : (priceDetail.last
              | hbCustomFormat
                : (priceDetail.last < 1 ? '$0,0[.]000' : '$0,0[.]00'))
        }}
      </span>
    </div>
    <div class="percentaje">
      <span
        [class.neutro]="priceDetail?.changeAvg === 0"
        [class.positive]="priceDetail?.changeAvg > 0"
        [class.negative]="priceDetail?.changeAvg < 0"
      >
        {{ priceDetail?.changeAvg | hbCustomFormat: '0,0.00%' }}
      </span>
    </div>
  </div>

  <div
    class="search-container-box"
    [ngClass]="{ 'search-container-box--usa': isUsaContract }"
  >
    <div class="result-search">
      <div class="searches-all">
        <div class="title-search" *ngIf="showItems && !isUsaContract">
          <button
            class="tab-button"
            [class.active-button]="selectedFilter === 0"
            [class.inactive-button]="selectedFilter !== 0"
            (click)="changeFilterTab(0)"
          >
            TODO
          </button>
          <button
            class="tab-button"
            [class.active-button]="selectedFilter === 1"
            [class.inactive-button]="selectedFilter !== 1"
            (click)="changeFilterTab(1)"
          >
            BMV
          </button>
          <button
            class="tab-button"
            [class.active-button]="selectedFilter === 2"
            [class.inactive-button]="selectedFilter !== 2"
            (click)="changeFilterTab(2)"
          >
            SIC
          </button>
        </div>
        <div class="list-results" id="search-box-scroll">
          <nav>
            <ul class="result-list" *ngIf="showItems" id="search-box-scroll">
              <ng-container *ngFor="let item of itemsToShow; let i = index">
                <li
                  *ngIf="item !== -1"
                  [tabIndex]="itemsToShow.indexOf(item)"
                  class="option"
                  (click)="rowSelected(item)"
                  attr.data-issueid="{{ item.issueID }}"
                  (keydown)="onItemKeyDown($event, item)"
                >
                  <div class="issueId">{{ item.issueID }}</div>
                  <div class="issueName">{{ item.issueName }}</div>
                </li>
              </ng-container>
            </ul>
            <ul class="result-list" *ngIf="showNoResult">
              <li class="option">
                <div class="item">No se encontraron resultados</div>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</div>
